import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetUxpHostInfoQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetUxpHostInfoQuery = { __typename?: 'Query', uxpHostInfo: { __typename?: 'UXPHostInfo', name: string, version: string, uiLocale?: string | null, pluginVersion: string, uxpVersion: string, schemaVersion: string } };


export const GetUxpHostInfo = /*#__PURE__*/ gql`
    query GetUxpHostInfo {
  uxpHostInfo {
    name
    version
    uiLocale
    pluginVersion
    uxpVersion
    schemaVersion
  }
}
    ` as unknown as DocumentNode<GetUxpHostInfoQuery, GetUxpHostInfoQueryVariables>;

          

          export const useGetUxpHostInfoQuery = (options?:QueryHookOptions<GetUxpHostInfoQuery, GetUxpHostInfoQueryVariables>) => useQuery(GetUxpHostInfo, options);

          

          export type GetUxpHostInfoQueryOptions = QueryHookOptions<GetUxpHostInfoQuery, GetUxpHostInfoQueryVariables>;

          

          export const useGetUxpHostInfoLazyQuery = (options?:LazyQueryHookOptions<GetUxpHostInfoQuery, GetUxpHostInfoQueryVariables>) => useLazyQuery(GetUxpHostInfo, options);

          

          export type GetUxpHostInfoQueryResult = ReturnType<typeof useGetUxpHostInfoQuery>;

          
